import { FC } from 'react'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'

import useUrls from '../../../services/useUrls'
import { PACKAGE_PIECES_DATA } from '../../../utils/constants'
import useCategoryDataStructure from '../../hooks/useCategoryDataStructure'
import { getPickerValue, handlePickerChange } from './util'
import BaseFilterPicker from './BaseFilterPicker'

import styles from '../../../styles/CatalogFilters.module.less'

const FILTERCODE = 'f_piece-package'
const TITLE = 'Pieces in a package'

interface PiecesPackagePickerProps {
  shouldCloseFilters: boolean
}
const PiecesPackagePicker: FC<PiecesPackagePickerProps> = ({ shouldCloseFilters }) => {
  const { pushT } = useUrls()
  const { query, asPath } = useRouter()
  const { selectedCategory } = useCategoryDataStructure()
  const { t } = useTranslation('products')

  const pickerValueData = PACKAGE_PIECES_DATA.map((value) => ({ label: `${value} ${t('pc_other')}`, value }))

  const pickerValue = getPickerValue(query, FILTERCODE)
  const label = t(TITLE)

  // Only render this picker if Single use gloves is selected
  if (selectedCategory !== 'c_single-use-gloves') return null
  return (
    <BaseFilterPicker
      data={pickerValueData}
      filterCode={FILTERCODE}
      value={pickerValue || undefined}
      label={pickerValue.length ? label : undefined}
      placeholder={label}
      isSort={false}
      onChange={() => handlePickerChange(pushT, query, asPath, FILTERCODE)}
      cleanable={false}
      className={styles['pieces-package-picker']}
      shouldCloseFilters={shouldCloseFilters}
    />
  )
}

export default PiecesPackagePicker
